import { useEffect } from "react";

/**
 *
 * @returns {*}
 */
export const detectIE = () => {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        let rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
};

Math.easeInOutQuad = function (currentTime, startValue, changeInValue, duration) {
  currentTime /= duration / 2
  if (currentTime < 1) {
    return changeInValue / 2 * currentTime * currentTime + startValue
  }

  currentTime--

  return -changeInValue / 2 * (currentTime * (currentTime - 2) - 1) + startValue
};

export const scrollTo = (element, to, duration) => {
  const start = element.scrollTop
  const change = to - start
  let currentTime = 0, increment = 20

  const animateScroll = () => {
    currentTime += increment
    const val = Math.easeInOutQuad(currentTime, start, change, duration)
    element.scrollTop = val
    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }
  animateScroll()
}

function getPathArray () {
  return window.location.pathname.split('/')
}

export const getLanguageFromUrl = () => {
  const pathArray = getPathArray()
  return pathArray.includes('en') ? 'en' : 'sr'
}

export const getSectionFromUrl = () => {
  const business = window.location.pathname.match(/(Biznis-korisnici|Business|business|biznis)/g) !== null
  const about = window.location.pathname.match(/(about-yettel|o-yettelu)/g) !== null

  if (business) {
    return 'business'
  } else if (about) {
    return 'about-yettel'
  } else {
    return 'consumer'
  }
}

export const createId = (prefix =  'id') => {
  return (prefix + String(performance.now()) + Math.random().toString(36)
    .substr(2)).substring(0, 18);
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export const getSessionOauthPath = (prefixUrl) => {
  if (prefixUrl.length > 0) {
    return '/' + prefixUrl + '/session-oauth'
  }
  return '/session-oauth'
}

export const useOutsideClick = (ref) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      ref.current.removeAttribute("open");
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};
